var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"},[_c('div',{staticClass:"content",staticStyle:{"margin-top":"30px"}},[_c(_vm.currentView,{tag:"component",attrs:{"contact":_vm.contact},on:{"step":_vm.inquiryForm}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }